import { Component, Output, EventEmitter, Input } from '@angular/core';
import { MigrationStateText } from '@shared';

@Component({
  selector: 'migrations-state-filter',
  templateUrl: './migrations-state-filter.component.html',
  styleUrls: ['./migrations-state-filter.component.scss'],
})
export class MigrationsStateFilterComponent {
  @Input() filterArray: any[] = [];
  @Output() filter: EventEmitter<string> = new EventEmitter();

  MigrationStateText = MigrationStateText;

  changeFilter(value: string) {
    this.filter.emit(value);
  }
}
